import { useEffect } from "react";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useState } from "react";
import AuthService from "../../../../AuthService.js";
import utils from "../../../../utils/index.js";
import SkelectonCard from "../../../Skeleton/SkelectonCard.js";

import { Box, Grid, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import {
  dangerCardHeader,
  grayColor,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  successCardHeader,
  warningCardHeader,
  yellowCardHeader,
} from "../../assets/jss/material-dashboard-react.js";

export default function CardQuick({ periodo, tipoPedido }) {
  let filter =
    (periodo.dataInicial
      ? "/" + periodo.dataInicial + "/" + periodo.dataFinal
      : "") +
    "/" +
    tipoPedido;

  return (
    <Grid container spacing={2} sx={{ p: 0, m: 0 }}>
      <Grid
        item
        sx={{ p: 0, m: 0, width: "100%" }}
        size={{ sm: 12, md: 6, lg: 3 }}
      >
        <Box sx={{ p: 0, m: 0, width: "100%" }}>
          <CardGenerico
            color="info"
            url={`/dashboard/cardquick/QUANTIDADE_PEDIDO${filter}`}
            icon={<ReceiptIcon fontSize="large" />}
            maskTypeValue="int"
          />
        </Box>
      </Grid>

      <Grid
        item
        sx={{ p: 0, m: 0, width: "100%" }}
        size={{ sm: 12, md: 6, lg: 3 }}
      >
        <Box sx={{ width: "100%" }}>
          <CardGenerico
            color="success"
            url={`/dashboard/cardquick/VALOR_TOTAL_VENDA${filter}`}
            icon={<AttachMoneyIcon fontSize="large" />}
            maskTypeValue="decimal"
          />
        </Box>
      </Grid>

      <Grid
        item
        sx={{ p: 0, m: 0, width: "100%" }}
        size={{ sm: 12, md: 6, lg: 3 }}
      >
        <CardGenerico
          color="primary"
          url={`/dashboard/cardquick/TICKET_MEDIO_VENDA${filter}`}
          icon={<TrendingFlatIcon fontSize="large" />}
          maskTypeValue="decimal"
        />
      </Grid>

      <Grid item size={{ sm: 12, md: 6, lg: 3 }}>
        <CardGenerico
          color="rose"
          url={`/dashboard/cardquick/QUANTIDADE_CUPOM_DESCONTO${filter}`}
          icon={<LoyaltyIcon fontSize="large" />}
          maskTypeValue="percent"
        />
      </Grid>
    </Grid>
  );
}

export function CardGenerico({ color, icon, url, maskTypeValue }) {
  let [informacao, setinformacao] = useState(0);
  let [loading, setloading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  function getInfo() {
    let service = new AuthService();
    service
      .get(url)
      .then((resp) => {
        setinformacao(resp);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.error(err);
        enqueueSnackbar("Erro ao carregar os dados do gráfico.", {
          variant: "error",
        });
      });
  }

  useEffect(() => {
    setloading(true);
    getInfo();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  const colorStyles = {
    warning: warningCardHeader,
    success: successCardHeader,
    danger: dangerCardHeader,
    info: infoCardHeader,
    primary: primaryCardHeader,
    rose: roseCardHeader,
    yellow: yellowCardHeader,
  };
  const baseStyle = {
    borderRadius: "1rem",
    minWidth: "70px",
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: grayColor[0],
    ...(color && colorStyles[color]),
  };
  return (
    <Box
      color={color}
      sx={{
        borderRadius: "1rem",
        boxShadow:
          " rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;",
      }}
    >
      <Box
        sx={{
          padding: "1rem",
          display: "flex",
        }}
      >
        <Box sx={baseStyle} color="white">
          {icon}
        </Box>
        {loading ? (
          <SkelectonCard />
        ) : (
          <Box sx={{ width: "100%", paddingX: "1rem" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: grayColor[0],
                  textAlign: "right",
                  fontSize: "14px",
                }}
              >
                {informacao.descricao}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: grayColor[2],
                  marginTop: "0px",
                  minHeight: "auto",
                  fontWeight: "300",
                  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                  marginBottom: "0.5rem",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  textDecoration: "none",
                  "& small": {
                    color: grayColor[1],
                    fontWeight: "400",
                    lineHeight: "1",
                  },
                }}
              >
                {maskTypeValue === "decimal"
                  ? utils.formatNumber(informacao.valor)
                  : maskTypeValue === "percent"
                  ? "% " + utils.formataMonetario(informacao.valor)
                  : maskTypeValue === "double"
                  ? utils.formataMonetario(informacao.valor)
                  : maskTypeValue === "data"
                  ? utils.formatarData(informacao.valor)
                  : Math.round(informacao.valor)}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
